import { Injectable } from '@angular/core';
import { PersistenceService, StorageType } from 'angular-persistence';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { Constant } from '../../infrastructure/constant';
import { User, ResponseModel } from '../../models';
import { BaseService } from '..';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService extends BaseService {

  constructor(protected messageService: MessageService, protected persistenceService: PersistenceService, protected httpClient: HttpClient, private router: Router) {
    super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "Account");
  }
  public isLoggedIn(): boolean {
    var isLogged = this.persistenceService.get(Constant.auths.isLoginIn, StorageType.LOCAL);
    if (isLogged == 'true') {
      return true;
    }
    return false;
  }

  // public login(userName: string, password: string) {
  //   var loginObj = new Object();
  //   loginObj["UserName"] = userName;
  //   loginObj["PassWord"] = password;
  //   this.postCustomApi("SignIn", loginObj).subscribe((ret) => {
  //     console.log(ret);
  //     if (ret.isSuccess == true) {
  //       this.messageService.add({ severity: 'success', summary: 'Đăng nhập thành công', detail: 'Đăng nhập thành công.' });
  //       var retData = ret["data"];
  //       this.persistenceService.set(Constant.auths.isLoginIn, 'true', { type: StorageType.LOCAL });
  //       this.persistenceService.set(Constant.auths.token, retData["token"], { type: StorageType.LOCAL });
  //       this.persistenceService.set(Constant.auths.userId, retData["userId"], { type: StorageType.LOCAL });
  //       this.persistenceService.set(Constant.auths.userName, retData["userName"], { type: StorageType.LOCAL });
  //       this.persistenceService.set(Constant.auths.fullName, retData["userFullName"], { type: StorageType.LOCAL });
  //       var routing = "";
  //       this.router.navigate([routing]);
  //     } else {
  //       this.messageService.add({ severity: 'warn', summary: 'Đăng nhập không thành công', detail: 'Đăng nhập không thành công.' });
  //     }
  //   });

  // }

  async login(userName: string, password: string): Promise<ResponseModel> {
    var loginObj = new Object();
    loginObj["userName"] = userName;
    loginObj["passWord"] = password;
    let ret = await super.postCustomApi("SignIn", loginObj).toPromise();
    return ret;
  }

  public getAccountInfo() {
    let cols = [Constant.classes.includes.user.hub, Constant.classes.includes.user.role, Constant.classes.includes.user.department];

    let id = this.persistenceService.get(Constant.auths.userId, StorageType.LOCAL);

    let params = new HttpParams();
    params = params.append("id", id);

    return super.getCustomApiPaging("get", cols, params);
  }

  public async getAccountInfoAsync(): Promise<User> {
    const res = await this.getAccountInfo().toPromise();
    if (res.isSuccess) {
      const data = res.data as User;
      return data;
    } else {
      return new User();
    }
  }

  public logout() {
    this.persistenceService.remove(Constant.auths.isLoginIn, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.token, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.userId, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.userName, StorageType.LOCAL);
    var routing = Constant.pages.login.alias;
    this.router.navigate([routing]);
  }

  public getToken(): string {
    return this.persistenceService.get(Constant.auths.token, StorageType.LOCAL);
  }

  public getUserId(): number {
    return this.persistenceService.get(Constant.auths.userId, StorageType.LOCAL);
  }

  public getUserName(): string {
    return this.persistenceService.get(Constant.auths.userName, StorageType.LOCAL);
  }

  public getFullName(): string {
    return this.persistenceService.get(Constant.auths.fullName, StorageType.LOCAL);
  }
}



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/services/auth/auth.service.ts